import React, { type JSX } from 'react';
import Body from '../Body/Body';
import Heading from '../Heading/Heading';

type Props = {
  marginTop?: number;
};

export default function BuildsNoDataPlaceholder({
  marginTop,
}: Props): JSX.Element {
  return (
    <section
      className={'builds-no-data-placeholder'}
      style={{ marginTop: marginTop ? `${marginTop}rem` : undefined }}
    >
      <div>
        <Heading level={3} styleLevel={2}>
          Stay Tuned
        </Heading>
        <Body>
          It looks like we don&apos;t have any data just yet. It could be three
          things:
          <ol>
            <li>
              The patch just released and we don&apos;t have enough logs yet.
              Come back later!
            </li>
            <li>We just partitioned. There&apos;ll be new data soon!</li>
            <li>
              The encounter you&apos;re looking at doesn&apos;t have enough
              kills yet.
            </li>
          </ol>
        </Body>
      </div>
    </section>
  );
}
